import { ChartService } from './chart.service';

export default angular
  .module('sfMobile.services.chart', [
    'sfMobile.constants.numbers-scale',
    'sfMobile.constants.colors',
  ])
  .factory('sfChartService', ChartService).name;
